/* Etiquetas multiidoma en castellano. */
export default {
  "qrExcursion.qrError.message": "Se ha producido un error al leer el QR: {error}",
  "qrExcursion.qrError.title": "Error de lectura",
  "qrExcursion.qrFormat.message": "El código QR no cumple el formato especificado.",
  "qrExcursion.qrFormat.title": "Error de formato",
};
